module.exports = __webpack_public_path__ + "static/img/crmLogo1.0225a2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/crm/crmLogo1.png
// module id = A/Wm
// module chunks = 2